























































































import { Component, Vue } from 'vue-property-decorator';
import { ActionSheet } from 'vant';
import RegisterForm from '@/components/RegisterForm.vue';
import { getUrlParam } from '@/utils/common';

@Component({
  name: 'SaveMoneyActivity',
  components: {
    [ActionSheet.name]: ActionSheet,
    RegisterForm
  }
})

export default class SaveMoneyActivity extends Vue {
  invitationCode = '';
  showRegisterBox = false;

  created() {
    document.title = '俏租机';
    this.invitationCode = getUrlParam('invitationCode');
  }

  // 展示注册弹窗
  goToRegister() {
    this.showRegisterBox = true;
  }
}
